<div *ngIf="showLabel else withoutLabel" class="form-row control password">
    <p class="label">Passwort</p>
    <ng-container *ngTemplateOutlet="input"></ng-container>
</div>

<ng-template #withoutLabel>
    <ng-container *ngTemplateOutlet="input"></ng-container>
</ng-template>

<ng-template #input>
    <input [disabled]="isDisabled" [type]="type" class="input" autocomplete="on" [(ngModel)]="value">
    <span class="eyes" [class.disabled]="isDisabled" [class.hide]="type === 'password'" (click)="!isDisabled && showHidePassword(type)"></span>
</ng-template>